import { render } from "./full-image-carousel.vue?vue&type=template&id=7870c564"
import script from "./full-image-carousel.vue?vue&type=script&lang=js"
export * from "./full-image-carousel.vue?vue&type=script&lang=js"

import "./full-image-carousel.vue?vue&type=style&index=0&id=7870c564&lang=scss"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__